module.exports = __webpack_public_path__ + "img/id-bracelet.e0b89d8c.jpg";